import { zodResolver } from "@mantine/form";
import { reminderDataSchema } from "beitary-shared";
import { z } from "zod";

const reminderFormSchema = reminderDataSchema;

export type ReminderFormValues = z.infer<typeof reminderFormSchema>;

export const rules = zodResolver(reminderFormSchema);
